export default "__VITE_ASSET__TuW2hiiS__"